import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { Form } from "@towersystems/roam-common-native";
import { Page } from "@towersystems/roam-common-native";
import { EditFilterQuickKeyRootParamList } from "../../../../types";
import { useEditTile } from "../../../../utilities/layout";
import { LayoutNodeFilterForm } from "../../components";
import { EditTileFooter } from "../EditQuickKeyRootScreen/components";

export type EditFilterQuickKeyScreenProps = NativeStackScreenProps<
  EditFilterQuickKeyRootParamList,
  "EditFilterQuickKeyScreen"
>;

export function EditFilterQuickKeyScreen({
  navigation,
}: EditFilterQuickKeyScreenProps) {
  const { item } = useEditTile();

  if (!item) {
    return null;
  }

  return (
    <Page
      title="Filter POS quick key"
      secondaryTitle="Configure filter quick key to filter products by category, department or supplier"
      footer={<EditTileFooter id={item.id} />}
    >
      <Form>
        <LayoutNodeFilterForm item={item.config} />
      </Form>
    </Page>
  );
}
